import Swiper from 'swiper/bundle';

class singleSwiper {
  constructor({ elm }) {
    const slide = elm.querySelectorAll('.swiper-slide');
    const slidable = slide.length > 1 ? true : false;
    const containerModifierClass = slidable ? 'is-active swiper-container-' : 'swiper-container-';
    this.swiper = new Swiper(elm, {
      containerModifierClass: containerModifierClass,
      slidesPerView: 1,
      spaceBetween: 16,
      centeredSlides: true,
      loop: slidable,
      allowTouchMove: true,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      speed: 1500,
      pagination: {
        el: elm.querySelector("[data-role='single-swiper-pagination']"),
        clickable: true,
      },
      navigation: {
        nextEl: elm.querySelector("[data-role='single-swiper-nav-next']"),
        prevEl: elm.querySelector("[data-role='single-swiper-nav-prev']"),
      },
      watchOverflow: true,
      on: {
        init: function(){
          this.autoplay.stop();
          setTimeout(() => {
            this.autoplay.start();
          }, 1500);
        },
        afterInit: () => {
          const activeBullet = elm.querySelector(".swiper-pagination-bullet-active");
          if (activeBullet) {
            this.updateProgress(activeBullet);
          }
        },
        slideChangeTransitionStart: () => {
          const activeBullet = elm.querySelector(".swiper-pagination-bullet-active");
          if (activeBullet) {
            this.updateProgress(activeBullet);
          }
        },
      }
    });
  }
  updateProgress(bullet) {
    let progress = 0;
    const duration = 6500;
    const startTime = performance.now();

    const animateProgress = (currentTime) => {
      // 経過時間を計算
      const elapsedTime = currentTime - startTime;

      // 経過時間に基づきprogressを更新 (0 ~ 100)
      progress = Math.min((elapsedTime / duration) * 100, 100);

      // 角度を計算
      const angle = (progress / 100) * 360;

      // conic-gradientを適用
      bullet.style.backgroundImage = `conic-gradient(
        #ea5541 0deg ${angle}deg, 
        #fff ${angle}deg 360deg
      )`;

      // アニメーションが完了していなければ続行
      if (progress < 100) {
        requestAnimationFrame(animateProgress);
      }
    };
    
    requestAnimationFrame(animateProgress);
  }
}

export default singleSwiper;
